import React from 'react';

import contactAttributes from '../cards/poi/contactAttributes';
import InfoCard from '../cards/poi/InfoCard';
import PoiDistanceList from 'components/lists/PoiDistanceList';
import PoiAttributesList from 'components/pois/PoiAttributesList';
import PoiStaticMap from './PoiStaticMap';
import Poi from 'models/Poi';

function PoiMapAndInfoBoxes({ poi, handleMapOpen }: { poi: Poi; handleMapOpen: () => void }) {
    const staticMapImage = poi.static_map_image;
    const poiContactAttributes = poi.attributes?.filter((attr) => contactAttributes.includes(attr.attribute.slug));

    return (
        <div className="space-y-6">
            <PoiStaticMap openMap={handleMapOpen} alt={`${poi.name} zemljevid`} image={staticMapImage} />
            {poi.attributes.length > 0 && (
                <>
                    <InfoCard>
                        <h4 className="text-brand font-serif">Lastnosti</h4>
                        <div className="mt-4">
                            <PoiAttributesList
                                attributes={poi.attributes.filter(
                                    (attr) => !contactAttributes.includes(attr.attribute.slug)
                                )}
                            />
                        </div>
                    </InfoCard>
                    {poiContactAttributes.length > 0 && (
                        <InfoCard>
                            <h4 className="text-brand font-serif">Kontakti</h4>
                            <div className="mt-4">
                                <PoiAttributesList attributes={poiContactAttributes} />
                            </div>
                        </InfoCard>
                    )}
                </>
            )}

            {poi.nearby_huts.length > 0 && (
                <InfoCard>
                    <h4 className="text-brand font-serif">Zavetišča v bližini</h4>
                    <div className="mt-4">
                        <PoiDistanceList pois={poi.nearby_huts.slice(0, 5)} />
                    </div>
                </InfoCard>
            )}
        </div>
    );
}

PoiMapAndInfoBoxes.propTypes = {};

export default PoiMapAndInfoBoxes;
